"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userReferralSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.userReferralSchema = zod_1.default.object({
    status: zod_1.default.enum(["INVITED", "REGISTERED", "PURCHASED"]),
    displayName: zod_1.default.string(),
    displayWhatsapp: zod_1.default.string(),
});
//# sourceMappingURL=userReferral.js.map